__turbopack_context__.v({
  "mark": "LocalHeroMark-module__P6oHAG__mark",
});
